<template>
  <transition name="mask">
    <div class="mask" v-if="display">
      <div class="modal-wrap" :style="{width:width,height:height,borderRadius:borderRadius}" v-if="display">
        <div class="modal-header" :style="{backgroundColor:headerColor,borderRadius:borderRadius}">
          <span> {{ title }}</span>
          <n-icon icon="iconbaseline-close-px" color="#fff" @click="handleClose" ></n-icon>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer">
          <!-- <button>确定</button>
          <button>取消</button> -->
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import NIcon from "../icon/NIcon.vue";
export default {
  components: { NIcon },
  name: "n-modal",
  props: {
    borderRadius:{
      default:'0px'
    },
    headerColor:{
      default:'#ec7a5d',
      type:String
    },
    width:{
      default:'400px',

    },
    height:{
      default:'300px',
    },
    title: {
      default: "",
      type: String,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: this.show,
    };
  },
  computed: {
    display() {
      return this.show;
    },
  },
  watch: {
    show: {
      handler() {
        this.visible = this.show;
      },
    },
  },
  methods: {
    handleClose() {
      console.log("close");
      this.visible = false;
      this.$emit("update:show", false);
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index:99999;
}
.modal-wrap {
  // width:400px;
  background-color: #fff;
  position: absolute;
  top:160px;
  .modal-header {
    padding: 0 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    background-color: red;
    color: #fff;
    // span {
    //   color: #ccc;
    // }
    // .n-icon {
    //   color: #666666;
    // }
  }
  // .modal-body {
  //   min-height: 320px;
  // }
}
.mask-enter-active,
.mask-leave-active {
  transition: opacity 0.4s linear;
}
.mask-enter,
.mask-leave-to {
  opacity: 0;
}

</style>
